var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wordbank-page"}},[_c('category-card',{staticClass:"card h-fill",attrs:{"id":"card-category"}}),_vm._v(" "),_c('wordbank-list-card',{staticClass:"card h-fill",attrs:{"id":"card-content"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5703555e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Wordbank/WordBankList.vue
// module id = null
// module chunks = 